export default __webpack_public_path__ + "static/media/appLogo2.cb9ddca8.png";